import { api } from '@jurnee/common/src/browser/Api';
import { PartnerJSON } from '@jurnee/common/src/entities/Partner';
import { PayoutBeneficiaryJSON } from '@jurnee/common/src/entities/PayoutBeneficiary';
import { List } from '@jurnee/common/src/serializers';
import type { BeneficiaryParams } from '@jurnee/common/src/services/AirwallexService/types';
import { AirwallexBeneficiary } from '@jurnee/common/src/services/AirwallexService/types';

interface AirwallexAuthDetails {
  authCode: string;
  clientId: string;
  codeVerifier: string;
}

export function getPayoutBeneficiaries(partnerId: PartnerJSON['id']): Promise<List<PayoutBeneficiaryJSON, never>> {
  return api.get(`/partners/${partnerId}/payout-beneficiaries`);
}

export function createPayoutBeneficiary(partnerId: PartnerJSON['id'], body: BeneficiaryParams): Promise<PayoutBeneficiaryJSON> {
  return api.post(`/partners/${partnerId}/payout-beneficiaries`, body);
}

export function updatePayoutBeneficiary(partnerId: PartnerJSON['id'], payoutBeneficiaryId: PayoutBeneficiaryJSON['id'], body: BeneficiaryParams): Promise<PayoutBeneficiaryJSON> {
  return api.put(`/partners/${partnerId}/payout-beneficiaries/${payoutBeneficiaryId}`, body);
}

export function getProviderBeneficiary(partnerId: PartnerJSON['id'], payoutBeneficiaryId: PayoutBeneficiaryJSON['id']): Promise<AirwallexBeneficiary> {
  return api.get(`/partners/${partnerId}/payout-beneficiaries/${payoutBeneficiaryId}/provider-beneficiary`);
}

export function getBeneficiaryComponentAuth(partnerId: PartnerJSON['id']): Promise<AirwallexAuthDetails> {
  return api.get(`/partners/${partnerId}/payout-beneficiaries/auth-component`);
}